'use client';

import React from 'react';

const BASE =
  'w-full h-[56px] px-4 text-[16px] ' +
  'border-2 border-[#D2D2D2] rounded-2xl ' +
  'bg-[#f9f9f9] ' +
  'focus:ring-2 focus:ring-[#F52F81] focus:border-transparent focus:outline-none ' +
  'placeholder:text-[#999999] text-[#333333]';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  as?: 'input';
};

const ComixInput = React.forwardRef<HTMLInputElement, InputProps>(function ComixInput(
  { className = '', as: _as, ...props },
  ref
) {
  return (
    <input
      ref={ref}
      {...props}
      className={`${BASE} ${className}`}
    />
  );
});

export default ComixInput;
